import CustomDateRangeModal from './CustomDateRangeModal';

export default CustomDateRangeModal;
